import { render, staticRenderFns } from "./VerifyEmailAddress.vue?vue&type=template&id=20625846&scoped=true&"
import script from "./VerifyEmailAddress.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20625846",
  null
  
)

export default component.exports